import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format crewSize for display. Handles both string ('4-5') and
 * object ({min, max, typical}) formats from AI extraction.
 */
export function formatCrewSize(value: unknown): string {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  if (typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    const min = obj.min ?? obj.minimum;
    const max = obj.max ?? obj.maximum;
    const typical = obj.typical;
    if (min != null && max != null) {
      return min === max ? String(min) : `${min}-${max}`;
    }
    if (typical != null) return String(typical);
    if (min != null) return `${min}+`;
    if (max != null) return `up to ${max}`;
  }
  return String(value);
}
